module.exports = "/_next/static/images/coming-soon-handwirted-text-3b6d071149e9872cf5f959f2dea71f8e.png";